import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  value: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String as PropType<'radio' | 'checkbox'>,
    default: 'checkbox',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:value'],
  setup(__props, { emit }) {

const props = __props





const onToggle = () => {
  if (!props.disabled) {
    emit('update:value', !props.value)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass({
      'nas-remote__checkbox': true,
      'is-checked': __props.value,
      'is-radio': __props.type === 'radio',
      'is-checkbox': __props.type === 'checkbox',
      'is-disabled': __props.disabled,
    }),
    onClick: _withModifiers(onToggle, ["stop"])
  }, null, 10, _hoisted_1))
}
}

})